/*
  Not fully migrated, this is here to support the footer migration.
  Please check and migrate correctly
*/

import type { RouteRecordRaw } from 'vue-router'

export const MILITARY_DISCOUNT = 'military_discount'

const routes: RouteRecordRaw[] = [
  {
    path: '/:locale/military-discount',
    name: MILITARY_DISCOUNT,
    component: () => import('./MilitaryDiscount.vue'),
    meta: {
      disableClientSideNavigation: () => true,
    },
  },
]

export default routes
